// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c42a3be3","554":"30f812e5","641":"5439e889","750":"245b55d6","857":"0661f24a","977":"e6ba3f30"}[chunkId] + ".chunk.js";
};